export default __webpack_public_path__ + "static/media/hama.f0a0b5dd.jpg";